import React, { useState, useEffect } from "react";
import { useSelector, connect } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import { LocalStorageService, toAbsoluteUrl } from "../../../services";
import {
  getListsCampaignData,
  listGetAllTags,
} from "../../../redux/actions/nrp/listActions";
import CustomToolbar from "./toolbar";
import "./grid.css";
import {
  EyeIcon,
  LockClosedIcon,
  LockOpenIcon,
  CheckCircleIcon,
  XCircleIcon,
} from "@heroicons/react/solid";

// get step data from redux main state
const data = (state) => state.nrpList;

const List = (props) => {
  let { campaginData, isLoading, customHeaders, tagsList } = useSelector(data);
  const [status, setStatus] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [pageNumber, setPageNumber] = useState(0);
  const [dataLoading, setDataLoading] = useState(isLoading);
  const [headers, setHeaders] = useState([]);
  const [allUsers, setallUsers] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [selectedUsersIds, setSelectedUsersIds] = React.useState([]);
  const [singleUserProfile, setSingleUserProfile] = useState({});
  const [overAllSelectedUsers, setOverAllSelectedUsers] = useState([]);
  const [allSelectedUsersIds, setAllSelectedUsersIds] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isCustomList, setIsCustomList] = useState(false);
  const [customFilters, setCustomFilters] = useState([]);
  const [campaign] = useState(LocalStorageService.getObject("campaign")[0]);
  const [sortingModal, setSortModel] = useState([{ field: null, sort: null }]);
  const [startDate, setstartDate] = useState(campaign && campaign.createdAt);
  const [endDate, setendDate] = useState(new Date());
  const [allLabels, setAllLabels] = useState([]);
  const [isMainCall, setIsMainCall] = useState(false);
  const [message, setMessage] = useState(false);

  const [isDefaultApi] = useState(false);

  useEffect(() => {
    if (isMainCall === true) {
      setHeaders([]);
      setRowData([]);
      setallUsers(0);
      props.getListsCampaignData(
        campaign,
        startDate,
        endDate,
        pageNumber,
        pageSize,
        status,
        searchValue,
        customFilters,
        sortingModal,
        isCustomList
      );
    }
  }, [
    pageNumber,
    pageSize,
    searchValue,
    startDate,
    endDate,
    customFilters,
    sortingModal,
    status,
    isCustomList,
    isDefaultApi,
  ]);

  const handleSelectionChange = (prodID) => {
    const selectedIDs = new Set(prodID);
    const selectedRows = rowData.filter((row) => selectedIDs.has(row.id));
    setSelectedRows(selectedRows);
    setSelectedUsersIds(prodID);
    setAllSelectedUsersIds(prodID);
    let data = [...overAllSelectedUsers, ...selectedRows];
    data = data.filter((row) => selectedIDs.has(row.id));
    setOverAllSelectedUsers([...new Set(data)]);
  };

  const handelCellClick = (params) => {
    setSingleUserProfile({});
    let { field, row } = params;
    if (field === "profile") {
      let data = row;
      setSingleUserProfile(data);
    }
  };
  let close = () => {
    setSingleUserProfile({});
  };

  let handelPage = (page) => {
    setDataLoading(!dataLoading);
    setPageNumber(page);
  };

  // get searched data from toolbar to parent component
  let handelDateChange = (startDate, endDate) => {
    setstartDate(startDate);
    setendDate(endDate);
  };

  // get searched data from toolbar to parent component
  let handelSearchCandidate = (searchValue) => {
    setSearchValue(searchValue);
    setPageNumber(0);
  };
  //  get all custom filter queries

  let getAllFilterQueries = (filters) => {
    setCustomFilters(filters);
    setPageNumber(0);
  };

  // Get status

  let getStatus = (st, filters, isCustomList) => {
    setStatus(isCustomList ? 1 : st ? st : status);
    setCustomFilters(filters);
    setIsCustomList(isCustomList);
    setPageNumber(0);
  };

  let defaultApiCall = () => {
    props.getListsCampaignData(
      campaign,
      startDate,
      endDate,
      pageNumber,
      pageSize,
      status,
      searchValue,
      customFilters,
      sortingModal,
      isCustomList
    );
  };

  useEffect(() => {
    setRowData([]);
    if (campaginData && campaginData) {
      let finalColumn =
        customHeaders && customHeaders.length > 0
          ? customHeaders
          : campaginData.headerColumnNames;
      for (let i = 0; i < finalColumn.length; i++) {
        const mdata = finalColumn[i];
        if (mdata.field === "userLockStatus") {
          mdata.headerName = "Lock Status";
          mdata.headerAlign = "center";
          mdata.align = "center";
          mdata.renderCell = (p) => {
            return (
              <p>
                {p.row.userLockStatus === "t" ? (
                  <LockClosedIcon className="w-6 h-6 text-[#5A5A5B] cursor-pointer" />
                ) : (
                  <LockOpenIcon className="w-6 h-6 text-[#5A5A5B] cursor-pointer" />
                )}
              </p>
            );
          };
        }
        if (mdata.field === "resume") {
          mdata.headerAlign = "center";
          mdata.align = "center";
          mdata.renderCell = (p) => {
            return (
              <p>
                {p.row.resume ? (
                  <CheckCircleIcon className="w-6 h-6 text-[green] cursor-pointer" />
                ) : (
                  <XCircleIcon className="w-6 h-6 text-[#5A5A5B] cursor-pointer" />
                )}
              </p>
            );
          };
        }
      }
      setHeaders(finalColumn);
      setRowData(campaginData.listBoardData);
      setallUsers(campaginData.totalUsers);
      let savedData = LocalStorageService.getObject(`selectedArray`);
      setSelectedUsersIds(savedData[pageNumber]);
    }
  }, [campaginData, pageNumber, pageSize, customHeaders]);

  useEffect(() => {
    if (allLabels.length === 0) {
      props.listGetAllTags(campaign);
    }
  }, []);
  useEffect(() => {
    if (tagsList) {
      setAllLabels(tagsList);
    }
  }, [tagsList]);

  useEffect(() => {
    if (allLabels && allLabels.length > 0) {
      let topCandidate =
        allLabels &&
        allLabels.filter((label) => {
          return label.name == "Top Candidates";
        });
      if (topCandidate && topCandidate[0] && topCandidate[0].id) {
        let filter = [
          {
            columnName: "tagId",
            columnType: "tagId",
            value: topCandidate && topCandidate[0] && topCandidate[0].id,
          },
        ];
        setCustomFilters(filter);
        setIsCustomList(true);
      } else {
        setPageNumber(0);
      }
      setIsMainCall(true);
    } else {
      setMessage(true);
      setIsMainCall(true);
    }
  }, [allLabels]);

  return (
    <div>
      <div className="mx-auto 2xl:w-9/12 xl:w-9/12 lg:w-9/12 w-11/12 mt-2 ">
        <div className="py-8 ">
          {campaginData && campaginData ? (
            <div>
              <div style={{ height: 700, width: "100%" }}>
                <DataGrid
                  onSelectionModelChange={handleSelectionChange}
                  loading={isLoading}
                  rowCount={parseInt(allUsers)}
                  checkboxSelection={true}
                  rows={rowData}
                  keepNonExistentRowsSelected
                  columns={[
                    {
                      headerName: (
                        <EyeIcon className="w-6 h-6 text-[#5A5A5B] cursor-pointer" />
                      ),
                      field: "profile",
                      renderCell: (cellValues) => {
                        return (
                          <EyeIcon className="w-6 h-6 text-[#5A5A5B] cursor-pointer" />
                        );
                      },
                      width: 50,
                    },
                    ...headers,
                  ]}
                  onPageChange={(page) => {
                    handelPage(page);
                  }}
                  // sortModel={sortingModal}
                  onSortModelChange={(newSortModel) => {
                    setSortModel(
                      newSortModel.length > 0
                        ? newSortModel
                        : [{ field: null, sort: null }]
                    );
                  }}
                  enableCellSelect={true}
                  onCellClick={handelCellClick}
                  disableSelectionOnClick={true}
                  paginationMode="server"
                  page={pageNumber}
                  pageSize={pageSize}
                  onPageSizeChange={(newPageSize) => {
                    setDataLoading(!dataLoading);
                    setPageSize(newPageSize);
                  }}
                  disableColumnMenu={true}
                  components={{
                    Toolbar: CustomToolbar,
                    // ColumnUnsortedIcon: () => {
                    //   return (
                    //     <EyeIcon className="w-6 h-6 text-[#5A5A5B] cursor-pointer" />
                    //   );
                    // },
                  }}
                  sortable={true}
                  componentsProps={{
                    toolbar: {
                      selectedRows,
                      selectedUsersIds,
                      campaign,
                      singleUserProfile,
                      total: allUsers,
                      close,
                      overAllSelectedUsers,
                      allSelectedUsersIds,
                      handelSearchCandidate,
                      handelDateChange,
                      getAllFilterQueries,
                      getStatus,
                      defaultApiCall,
                    },
                    pagination: {
                      labelRowsPerPage: "Candidate Per Page",
                    },
                  }}

                  //   initialState={{
                  //     pinnedColumns: { left: [GRID_CHECKBOX_SELECTION_COL_DEF.field] },
                  // }}
                />
              </div>
            </div>
          ) : (
            <div>
              {message ? (
                <div style={{ height: 700, width: "100%" }}>
                  <DataGrid
                    onSelectionModelChange={handleSelectionChange}
                    loading={isLoading}
                    rowCount={parseInt(allUsers)}
                    checkboxSelection={true}
                    rows={rowData}
                    keepNonExistentRowsSelected
                    columns={[
                      {
                        headerName: (
                          <EyeIcon className="w-6 h-6 text-[#5A5A5B] cursor-pointer" />
                        ),
                        field: "profile",
                        renderCell: (cellValues) => {
                          return (
                            <EyeIcon className="w-6 h-6 text-[#5A5A5B] cursor-pointer" />
                          );
                        },
                        width: 50,
                      },
                      ...headers,
                    ]}
                    onPageChange={(page) => {
                      handelPage(page);
                    }}
                    // sortModel={sortingModal}
                    onSortModelChange={(newSortModel) => {
                      setSortModel(
                        newSortModel.length > 0
                          ? newSortModel
                          : [{ field: null, sort: null }]
                      );
                    }}
                    enableCellSelect={true}
                    onCellClick={handelCellClick}
                    disableSelectionOnClick={true}
                    paginationMode="server"
                    page={pageNumber}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => {
                      setDataLoading(!dataLoading);
                      setPageSize(newPageSize);
                    }}
                    disableColumnMenu={true}
                    components={{
                      Toolbar: CustomToolbar,
                      // ColumnUnsortedIcon: () => {
                      //   return (
                      //     <EyeIcon className="w-6 h-6 text-[#5A5A5B] cursor-pointer" />
                      //   );
                      // },
                    }}
                    sortable={true}
                    componentsProps={{
                      toolbar: {
                        selectedRows,
                        selectedUsersIds,
                        campaign,
                        singleUserProfile,
                        total: allUsers,
                        close,
                        overAllSelectedUsers,
                        allSelectedUsersIds,
                        handelSearchCandidate,
                        handelDateChange,
                        getAllFilterQueries,
                        getStatus,
                        defaultApiCall,
                      },
                      pagination: {
                        labelRowsPerPage: "Candidate Per Page",
                      },
                    }}
                  />
                </div>
              ) : (
                <div className="flex justify-center items-center">
                  <img
                    src={toAbsoluteUrl("/media/nrp/dashboard/logo.gif")}
                    alt="TTG LOGO"
                    style={{
                      width: "100px",
                      height: "90px",
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {
  getListsCampaignData,
  listGetAllTags,
})(List);
